import { BrowserRouter, Routes, Route } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
import './App.css';
import Footer from './component/Footer';
import Nav from './component/Nav';
import Homepages from './Pages/homepages/Homepages';
import Contact from './Pages/Contact/Contact';
import Consultatii from './Pages/Consultatii/Consultatii';
import NotFound from './Pages/NotFound';
import DespreNoi from './Pages/DespreNoi/DespreNoi';
import OchelariDeVedere from './Pages/OchelariDeVedere/OchelariDeVedere';
import OchelariDeSoare from './Pages/OchelariDeSoare/OchelariDeSoare';
import LentileDeContact from './Pages/LentileDeContact/LentileDeContact';

function App() {
  return (
    <BrowserRouter>
      <div className="my-app">
        <Nav />
        <Routes>
          <Route path="/" element={<Homepages />} />
          <Route path="/Homepages" element={<Homepages />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/despre-noi" element={<DespreNoi />} />
          <Route path="/consultatii" element={<Consultatii />} />
          <Route path="/ochelari-de-vedere" element={<OchelariDeVedere />} />
          <Route path="/ochelari-de-soare" element={<OchelariDeSoare />} />
          <Route path="/lentile-de-contact" element={<LentileDeContact />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
        <Footer />
      </div>
    </BrowserRouter>
  );
}

export default App;
